import Equipment from './equipment';

export default class Wings extends Equipment {}
